import React from 'react'

interface Props {
  className?: string
  width?: string | number
  height?: string | number
}

export const LMMarmotLogo: React.FC<Props> = ({ className, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 164.44614 84.569536"
      version="1.1"
      id="svg1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g
        id="layer1"
        transform="translate(-353.78433,-142.30909)"
        style={{ display: 'inline' }}
      >
        <path
          style={{ opacity: 0.757786, fill: 'var(--primary)', strokeWidth: 2.20852 }}
          d="m 353.78435,226.35375 48.86334,-84.04467 33.22694,55.81255 -15.63632,28.23212 -16.93911,-27.14622 -15.419,27.58052 z"
          id="path15"
        />
        <path
          style={{ display: 'inline', opacity: 0.757786, fill: 'var(--primary)', strokeWidth: 2.20852 }}
          d="m 518.2305,226.44432 -48.86334,-84.04467 -33.22694,55.81256 15.63632,28.23211 16.93911,-27.14624 15.419,27.58054 z"
          id="path15-4"
        />
      </g>
    </svg>
  )
}

export default LMMarmotLogo
